import langHomeCountDown from './features/count-down/langs/langHomeCountDown';
import langHomeIndex from './features/index/langs/langHomeIndex';

const HomeLangs = [langHomeCountDown, langHomeIndex];

export default HomeLangs;
